import React from "react"
import { LOGOS_CONSTANT } from "../../../constants/ImageConstants.js"
import {
  ACTIVITY_TYPE_ENUM,
  DATE_TYPE_ENUM,
  INSPECTION_STATUS_ENUM,
  INSPECTION_STATUS_STRING,
  UNIT_STRING
} from "../../../constants/StringConstant.js"
import {
  stringFormatting,
  convertDotToComma,
  convertDotToCommaZero,
  convertM2ToHectare,
  toKilogram
} from "../../../app/helpers/TextHelper.js"
import { timeStampToDate } from "../../../app/helpers/DateHelper.js"
import { CvlDocument } from "../../atoms/Tabel/CvlDocument.jsx"

const LabelValue = ({ label, value }) => {
  return (
    <div className={"d-flex"}>
      <div className={"w-50"}>{label}</div>
      <div className={"mr-2"}>:</div>
      <div className={"w-full"}>{value}</div>
    </div>
  )
}

const LabelColumn = ({ label, value, colspan, labelClass, valueClass }) => {
  return (
    <>
      <td className={labelClass ? labelClass : "w-180px"}>{label}</td>
      <td className={"w-10px"}>:</td>
      <td colSpan={colspan} className={valueClass ?? "bottom-line w-650px"}>
        {value}
      </td>
    </>
  )
}

export const QAPhaseActivityDocument = ({ data }) => {
  const header = (
    <div className={"submission-header"}>
      <div className={"border border-dark mb-5"}>
        <div className={"w-full d-flex align-content-center justify-content-center"}>
          <div className={"d-flex justify-content-center align-items-center"}>
            <img src={LOGOS_CONSTANT.MAI} className={""} />
          </div>
          <div
            className={
              "d-flex justify-content-center align-items-center flex-grow-1 border-right border-left border-1 border-dark font-size-h1 font-weight-bolder"
            }>
            <div className={"flex-row"}>
              <div>DOKUMEN</div>
              <div>FORMULIR</div>
            </div>
          </div>
          <div className={"d-flex flex-column flex-grow-1 txt-14 p-3"}>
            <LabelValue label={"No. Dokumen"} value={"DF.PO.S.QA.01.02"} />
            <LabelValue label={"Tanggal Berlaku"} value={"7 Juli 2023"} />
            <LabelValue label={"Tanggal Revisi"} value={"8 Maret 2024"} />
            <LabelValue label={"Revisi"} value={"1"} />
            <LabelValue label={"Halaman"} value={"1 dari 1"} />
          </div>
        </div>
        <div
          className={
            "w-full d-flex justify-content-center align-items-center text-uppercase txt-18 border-top border-1 border-dark p-1"
          }>{`FORMULIR ${
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY
            ? "LAPORAN PEMERIKSAAN PENDAHULUAN"
            : data?.activity_type_enum === ACTIVITY_TYPE_ENUM.HARVEST
            ? `PEMERIKSAAN PERALATAN DAN PENGAWASAN PANEN`
            : `LAPORAN PEMERIKSAAN LAPANGAN PERTANAMAN`
        }`}</div>
      </div>
      <div className={"d-flex justify-content-between align-items-start"}>
        <table className={"border-padding-0 border-dark table-fixed w-full"}>
          <tr>
            <td className={"w-50"}>
              {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY
                ? `LAPORAN PEMERIKSAAN PENDAHULUAN`
                : data?.activity_type_enum === ACTIVITY_TYPE_ENUM.HARVEST
                ? `LAPORAN PEMERIKSAAN PERALATAN DAN PENGAWASAN PANEN`
                : `LAPORAN PEMERIKSAAN PERTANAMAN`}
            </td>
            <td className={"w-50"}>NOMOR INDUK : {data?.certification_number}</td>
          </tr>
          <tr>
            <td>NOMOR BERKAS : {data?.document_number}</td>
            <td>
              TAHUN &nbsp;&nbsp;&nbsp;&nbsp;:{" "}
              {data?.file_number.slice(-4) || new Date().getFullYear()}
            </td>
          </tr>
        </table>
      </div>
    </div>
  )

  const body = (
    <div className={"w-full txt-14"} style={{ paddingTop: "200px" }}>
      {data?.activity_type_enum !== ACTIVITY_TYPE_ENUM.PRELIMINARY && (
        <div className={"d-flex font-weight-bolder justify-content-center txt-14"}>
          {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE
            ? `Fase Pemeriksaan : Vegetatif`
            : data?.activity_type_enum === ACTIVITY_TYPE_ENUM.HARVEST
            ? `Fase Pemeriksaan : Panen`
            : data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE
            ? `Fase Pemeriksaan : Masak`
            : `Fase Pemeriksaan : Berbunga`}
        </div>
      )}
      <div className={"d-flex"}>
        <div className={"w-20px"}>1</div>
        <table className={"w-full"}>
          {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY && (
            <tr>
              <LabelColumn label={"Komoditas"} value={"Jagung Hibrida"} colspan={2} />
            </tr>
          )}
          <tr>
            <LabelColumn
              label={"Nama Produsen Benih"}
              value={"PT. MAXXI AGRI INDONESIA"}
              colspan={2}
            />
          </tr>
          <tr>
            <LabelColumn
              label={"Alamat"}
              value={"Jl. Raya Sumobito KM2, Desa Betek, Mojoagung, Jombang, Jawa Timur"}
              colspan={2}
            />
          </tr>
          <tr>
            <LabelColumn label={"Jenis Tanaman"} value={"Jagung Hibrida"} colspan={2} />
          </tr>
        </table>
      </div>
      <div className={"d-flex"}>
        <div className={"w-20px"}>2</div>
        <table className={"w-full"}>
          {data?.activity_type_enum !== ACTIVITY_TYPE_ENUM.PRELIMINARY && (
            <tr>
              <p className={"mb-0"}>{"Letak Tanah"}</p>
            </tr>
          )}
          <tr>
            <LabelColumn label={"Blok"} value={stringFormatting(data?.block_code)} colspan={6} />
          </tr>
          <tr>
            <LabelColumn
              label={"Kampung"}
              value={stringFormatting(data?.sub_district)}
              colspan={2}
            />
            <LabelColumn label={"Kecamatan"} value={stringFormatting(data?.district)} colspan={2} />
          </tr>
          <tr>
            <LabelColumn label={"Desa"} value={stringFormatting(data?.sub_district)} colspan={2} />
            <LabelColumn label={"Kabupaten"} value={stringFormatting(data?.regency)} colspan={2} />
          </tr>
        </table>
      </div>
      {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY && (
        <div className={"d-flex"}>
          <div className={"w-20px"}>3</div>
          <table className={"w-full"}>
            <tr>
              <p className={"mb-0"}>{"Rencana Penanaman"}</p>
            </tr>
            <tr>
              <LabelColumn label={"Komoditas"} value={"Jagung Hibrida"} colspan={2} />
              <LabelColumn label={"Varietas"} value={stringFormatting(data?.variety)} colspan={2} />
            </tr>
            <tr>
              <LabelColumn
                label={"Luas Areal"}
                value={convertDotToComma(
                  convertM2ToHectare(data?.planting_realization?.land_area_submit, 4),
                  UNIT_STRING.HA
                )}
                colspan={2}
              />
              <LabelColumn
                label={"Kelas Benih"}
                value={stringFormatting(data?.seed_class)}
                colspan={2}
              />
            </tr>
            <tr>
              <p className={"mb-0"}>{"Tanggal Rencana Tanam"}</p>
            </tr>
            <tr>
              <LabelColumn
                label={"Induk Betina"}
                value={stringFormatting(
                  timeStampToDate(
                    data?.planting_realization.female_planting_date,
                    DATE_TYPE_ENUM.ISO_DATE_ID
                  )
                )}
                colspan={2}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Induk Jantan"}
                value={stringFormatting(
                  timeStampToDate(
                    data?.planting_realization.male_planting_date,
                    DATE_TYPE_ENUM.ISO_DATE_ID
                  )
                )}
                colspan={2}
              />
            </tr>
          </table>
        </div>
      )}
      {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY && (
        <div className={"d-flex"}>
          <div className={"w-20px"}>4</div>
          <table className={"w-full"}>
            <tr>
              <p className={"mb-0"}>{"Sumber Benih Digunakan"}</p>
            </tr>
            <tr>
              <LabelColumn
                label={"Nama Induk Betina"}
                value={stringFormatting(data.source_seed_used?.female?.name)}
                colspan={2}
              />
              <LabelColumn
                label={"Nama Induk Jantan"}
                value={stringFormatting(data.source_seed_used?.male?.name)}
                colspan={2}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Jumlah"}
                value={toKilogram(stringFormatting(data.source_seed_used?.female?.seed_total))}
                colspan={2}
              />
              <LabelColumn
                label={"Jumlah"}
                value={toKilogram(stringFormatting(data.source_seed_used?.male?.seed_total))}
                colspan={2}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Kelas Benih"}
                value={stringFormatting(data.source_seed_used?.female?.seed_class)}
                colspan={2}
              />
              <LabelColumn
                label={"Kelas Benih"}
                value={stringFormatting(data.source_seed_used?.male?.seed_class)}
                colspan={2}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Kode Nomor Induk"}
                value={stringFormatting(data.source_seed_used?.female?.variety_code)}
                colspan={2}
              />
              <LabelColumn
                label={"Kode No. Induk"}
                value={stringFormatting(data.source_seed_used?.male?.variety_code)}
                colspan={2}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Nomor Lot"}
                value={stringFormatting(data.source_seed_used?.female?.lot_number)}
                colspan={2}
              />
              <LabelColumn
                label={"Nomor Lot"}
                value={stringFormatting(data.source_seed_used?.male?.lot_number)}
                colspan={2}
              />
            </tr>
          </table>
        </div>
      )}
      {data?.activity_type_enum !== ACTIVITY_TYPE_ENUM.PRELIMINARY && (
        <div className={"d-flex"}>
          <div className={"w-20px"}>3</div>
          <table className={"w-full"}>
            <tr>
              <p className={"mb-0 w-180px"}>{"Realisasi Penanaman"}</p>
            </tr>
            <tr>
              <LabelColumn
                label={"Luas Areal Aju"}
                value={`${convertDotToComma(
                  convertM2ToHectare(data?.planting_realization?.land_area_submit, 4)
                )} Ha`}
                colspan={2}
              />
              <LabelColumn label={"Varietas"} value={stringFormatting(data?.variety)} colspan={2} />
            </tr>
            <tr>
              <LabelColumn
                label={"Luas Areal Lulus"}
                value={`${convertDotToComma(
                  convertM2ToHectare(data?.summary?.land_area_passed, 4)
                )} Ha`}
                colspan={2}
              />
              <LabelColumn
                label={"Kelas Benih"}
                value={stringFormatting(data?.seed_class)}
                colspan={2}
              />
            </tr>
            {data?.activity_type_enum !== ACTIVITY_TYPE_ENUM.HARVEST && (
              <>
                <tr>
                  <p className={"mb-0"}>{"Tanggal Realisasi Tanam"}</p>
                </tr>
                <tr>
                  <LabelColumn
                    label={"Induk Betina"}
                    value={stringFormatting(
                      timeStampToDate(
                        data?.planting_realization?.female_planting_date,
                        DATE_TYPE_ENUM.ISO_DATE_ID
                      )
                    )}
                    colspan={5}
                  />
                </tr>
                <tr>
                  <LabelColumn
                    label={"Induk Jantan"}
                    value={stringFormatting(
                      timeStampToDate(
                        data?.planting_realization?.male_planting_date,
                        DATE_TYPE_ENUM.ISO_DATE_ID
                      )
                    )}
                    colspan={5}
                  />
                </tr>
              </>
            )}
          </table>
        </div>
      )}
      {data?.activity_type_enum !== ACTIVITY_TYPE_ENUM.HARVEST && (
        <div className={"d-flex"}>
          <div className={"w-20px"}>
            {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY ? 5 : 4}
          </div>
          <table className={"w-full"}>
            <tr>
              <p className={"mb-0"}>
                {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY
                  ? "Isolasi/Tanaman Sekitar"
                  : `Hasil Pemeriksaan`}
              </p>
            </tr>
            {/*VEGETATIVE, FLOWERING, RIPE*/}
            {(data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
              data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING ||
              data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE) && (
              <tr>
                <LabelColumn label={"Isolasi"} value={""} colspan={2} valueClass={""} />
              </tr>
            )}
            <tr>
              <LabelColumn
                label={"Utara"}
                value={stringFormatting(data?.isolation?.north_plant)}
                colspan={2}
              />
              <LabelColumn
                label={"Timur"}
                value={stringFormatting(data?.isolation?.east_plant)}
                colspan={2}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Selatan"}
                value={stringFormatting(data?.isolation?.south_plant)}
                colspan={2}
              />
              <LabelColumn
                label={"Barat"}
                value={stringFormatting(data?.isolation?.west_plant)}
                colspan={2}
              />
            </tr>
            {/*VEGETATIVE, FLOWERING, RIPE*/}
            {(data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE ||
              data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING ||
              data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE) && (
              <>
                <tr>
                  <LabelColumn
                    label={"Sifat-sifat tanaman sesuai dengan varietasnya"}
                    colspan={5}
                    labelClass={"w-180px d-inherit"}
                    value={
                      data?.result?.plant_characteristic === null
                        ? "-"
                        : data?.result?.plant_characteristic
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }
                  />
                </tr>
                <tr>
                  <LabelColumn
                    label={"Keadaan hama/penyakit"}
                    labelClass={"w-180px d-inherit"}
                    value={stringFormatting(data?.result?.pest_condition)}
                    colspan={5}
                  />
                </tr>
                <tr>
                  <LabelColumn
                    label={"Keadaan rerumputan"}
                    labelClass={"w-180px d-inherit"}
                    value={stringFormatting(data?.result?.grass_condition)}
                    colspan={5}
                  />
                </tr>
                <tr>
                  <LabelColumn
                    label={"Perkiraan tanggal panen"}
                    value={
                      data?.result?.estimate_harvest_date
                        ? timeStampToDate(
                            data?.result?.estimate_harvest_date,
                            DATE_TYPE_ENUM.ISO_DATE_ID
                          )
                        : "-"
                    }
                    colspan={2}
                  />
                  <LabelColumn
                    label={"Prakiraan produksi benih"}
                    value={
                      data?.result?.estimate_seed_production
                        ? toKilogram(data?.result?.estimate_seed_production)
                        : "- Kg"
                    }
                    colspan={2}
                  />
                </tr>
              </>
            )}
          </table>
        </div>
      )}
      {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY && (
        <div className={"d-flex"}>
          <div className={"w-20px"}>6</div>
          <table className={"w-full"}>
            <tr>
              <p className={"mb-0"}>{"Sejarah Lapang"}</p>
            </tr>
            <tr>
              <LabelColumn
                label={"Bekas Tanaman"}
                value={stringFormatting(data?.result?.plant_type)}
                colspan={2}
              />
              <LabelColumn
                label={"Varietas"}
                value={stringFormatting(data?.result?.variety)}
                colspan={2}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Kelas"}
                value={stringFormatting(data?.result?.seed_class)}
                colspan={2}
              />
              <LabelColumn
                label={"Bekas Bera"}
                value={stringFormatting(data?.result?.bero)}
                colspan={2}
              />
            </tr>
          </table>
        </div>
      )}
      {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY && (
        <div className={"d-flex"}>
          <div className={"w-20px"}>7</div>
          <table className={"w-full"}>
            <tr>
              <p className={"mb-0"}>{"Hasil Pemeriksaan"}</p>
            </tr>
            <tr>
              <LabelColumn
                label={"Kebenaran Letak Areal"}
                value={data?.result?.area_location_validation ? "Sesuai" : "Tidak Sesuai"}
                colspan={2}
              />
              <LabelColumn
                label={"Kebenaran Luas Areal"}
                value={data?.result?.area_land_validation ? "Sesuai" : "Tidak Sesuai"}
                colspan={2}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Benih Sumber Digunakan"}
                value={data?.result?.seed_source_used ? "Sesuai" : "Tidak Sesuai"}
                colspan={2}
                valueClass={"bottom-line w-650px ml-0 pl-0"}
              />
              <LabelColumn
                label={"Sejarah Lapang"}
                value={data?.result?.land_history ? `Sesuai` : `Tidak Sesuai`}
                colspan={2}
              />
            </tr>
          </table>
        </div>
      )}
      {(data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE ||
        data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
        data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING) && (
        <div>
          <CvlDocument name={"CVL/Tipe Simpang Hibrida Betina"} data={data?.cvl?.female} />
          <CvlDocument
            name={"CVL/Tipe Simpang Hibrida Jantan"}
            data={
              data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
              data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING
                ? data?.cvl?.male
                : null
            }
          />
          <CvlDocument
            name={"Bunga Jantan Tertinggal Pada Induk Betina"}
            data={
              data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING
                ? data?.cvl?.male_on_female
                : null
            }
          />
          <CvlDocument
            name={"Induk Jantan/Restorer yang Tertinggal"}
            data={
              data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE
                ? data?.cvl?.male_flower_left
                : null
            }
          />
        </div>
      )}
      {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.HARVEST && (
        <div className={"d-flex"}>
          <div className={"w-20px"}>4</div>
          <table className={"w-full"}>
            <tr>
              <p className={"mb-0"}>{"Hasil Pemeriksaan"}</p>
            </tr>
            <tr>
              <LabelColumn
                label={"Tgl. Awal Panen"}
                value={timeStampToDate(
                  data?.result?.harvest_start_date,
                  DATE_TYPE_ENUM.ISO_DATE_ID
                )}
                colspan={8}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Tgl. Akhir Panen"}
                value={timeStampToDate(data?.result?.harvest_end_date, DATE_TYPE_ENUM.ISO_DATE_ID)}
                colspan={8}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Umur tanaman saat panen"}
                value={stringFormatting(data?.result?.hst, "HST")}
                colspan={8}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Lama Panen"}
                value={stringFormatting(data?.result?.harvest_day, "Hari")}
                colspan={8}
              />
            </tr>
            <tr>
              <LabelColumn
                label={"Kondisi lingkungan/cuaca saat panen"}
                value={stringFormatting(data?.result?.weather_condition)}
                colspan={8}
              />
            </tr>
            <tr>
              <p className={"mb-0"}>{"Peralatan saat panen"}</p>
            </tr>
            <tbody className={"w-full"}>
              <tr>
                <LabelColumn
                  label={"Sabit/Alat/Mesin Panen"}
                  value={data?.result?.harvest_tool ? "Memenuhi Syarat" : "Tidak Memenuhi Syarat"}
                  colspan={8}
                  valueClass={"w-200px"}
                  labelClass={"pl-5"}
                />
              </tr>
              <tr>
                <LabelColumn
                  label={"Wadah Benih/Karung"}
                  value={data?.result?.sack ? "Memenuhi Syarat" : "Tidak Memenuhi Syarat"}
                  colspan={8}
                  valueClass={"w-200px"}
                  labelClass={"pl-5"}
                />
              </tr>
              <tr>
                <LabelColumn
                  label={"Timbangan"}
                  value={data?.result?.weight ? "Memenuhi Syarat" : "Tidak Memenuhi Syarat"}
                  colspan={8}
                  valueClass={"w-200px"}
                  labelClass={"pl-5"}
                />
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.HARVEST && (
        <div className={"d-flex"}>
          <div className={"w-20px"}>5</div>
          <table className={"w-full"}>
            <tr>
              <LabelColumn
                label={"Juml. Calon Benih Kering Panen (gelondong) yang Dihasilkan"}
                labelClass={"w-50"}
                value={data?.potential_seeds ? toKilogram(data?.potential_seeds, false) : "-"}
                valueClass={"bottom-line w-full"}
              />
            </tr>
          </table>
        </div>
      )}
      <div className={"d-flex flex-column ml-6 mb-4 mt-2"}>
        <table className={"w-full"}>
          <tr>
            <LabelColumn
              label={"Kesimpulan/Rekomendasi"}
              value={
                data?.activity_status_enum === null
                  ? ""
                  : data?.activity_status_enum === INSPECTION_STATUS_ENUM.PASS
                  ? INSPECTION_STATUS_STRING.PASS
                  : data?.activity_status_enum === INSPECTION_STATUS_ENUM.PARTIAL_PASS
                  ? INSPECTION_STATUS_STRING.PARTIAL_PASS
                  : INSPECTION_STATUS_STRING.NOT_PASS
              }
              labelClass={"w-180px"}
              colspan={2}
              valueClass={"w-650px"}
            />
          </tr>
        </table>
        <table className={"w-full"}>
          {data?.activity_type_enum !== ACTIVITY_TYPE_ENUM.PRELIMINARY &&
            data?.summary?.area_list?.map((item, index) => (
              <tr key={index}>
                {index === 0 ? (
                  <>
                    <td>Keterangan</td>
                    <td className={"w-10px"}>:</td>
                  </>
                ) : (
                  <>
                    <td></td>
                    <td></td>
                  </>
                )}
                <td className={"w-full"}>
                  <div className={"d-flex"}>
                    <div className={"pr-2"}>{`${item.name} ${
                      item.area_status_enum === INSPECTION_STATUS_ENUM.PARTIAL_PASS
                        ? INSPECTION_STATUS_STRING.PASS + `,`
                        : item.area_status_enum === INSPECTION_STATUS_ENUM.NOT_PASS
                        ? INSPECTION_STATUS_STRING.NOT_PASS + `,`
                        : item.area_status_enum === INSPECTION_STATUS_ENUM.PASS
                        ? INSPECTION_STATUS_STRING.PASS
                        : ""
                    } ${
                      item.area_status_enum === INSPECTION_STATUS_ENUM.PARTIAL_PASS
                        ? `${convertDotToComma(convertM2ToHectare(item.total_area_pass, 4))} Ha, ${
                            item.area_not_pass_location
                              ? ` sebelah ${item.area_not_pass_location} ${
                                  item.area_status_enum === INSPECTION_STATUS_ENUM.PARTIAL_PASS
                                    ? INSPECTION_STATUS_STRING.NOT_PASS
                                    : ""
                                },`
                              : ``
                          }  ${
                            item.male_row_not_pass ? `${item.male_row_not_pass} Baris Jantan,` : ``
                          }`
                        : ``
                    } ${
                      item.reason || item.area_status_enum === INSPECTION_STATUS_ENUM.NOT_PASS
                        ? item.reason
                        : ""
                    }`}</div>
                  </div>
                </td>
              </tr>
            ))}
        </table>
        {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY && (
          <table className={"w-full"}>
            <tr>
              <LabelColumn
                label={"Keterangan"}
                value={
                  data?.summary?.land_area_passed
                    ? `Areal Sertifikasi Benih Lulus Seluas ${convertDotToCommaZero(
                        convertM2ToHectare(data?.summary?.land_area_passed, 4)
                      )} Ha`
                    : "-"
                }
                labelClass={"w-180px"}
                colspan={2}
              />
            </tr>
          </table>
        )}
      </div>
    </div>
  )
  const footer = (
    <div className={"w-full txt-14 p-0 m-0 ml-6"}>
      <table className={"w-full p-0"}>
        <tr>
          <td className={"w-20"} />
          <td className={"w-60"} />
          <td className={"w-20"} align={"center"}>
            {`Jombang, ${timeStampToDate(data?.activity_date, DATE_TYPE_ENUM.ISO_DATE_ID)}`}
          </td>
        </tr>
        <tr>
          <td>
            <div>Pemohon,</div>
            <div>Manager FCP</div>
          </td>
          <td />
          <td align={"center"}>Petugas QA Lapang</td>
        </tr>
        <tr>
          <td colSpan={3} style={{ height: "70px" }} align={"center"}>
            <div>Mengetahui,</div>
            <div>Manager QA</div>
          </td>
        </tr>
        <tr>
          <td className={"font-weight-bolder underline"}>{"M. Rizki Abadi"}</td>
          <td align={"center"} style={{ height: "70px" }} />
          <td className={"font-weight-bolder underline"} align={"center"}>
            {data?.inspection_by}
          </td>
        </tr>
        <tr>
          <td colSpan={3} />
        </tr>
        <tr>
          <td />
          <td className={"font-weight-bolder underline"} align={"center"}>
            {"Lutfianah"}
          </td>
          <td />
        </tr>
      </table>
    </div>
  )

  return (
    <div className={"d-none d-print-block position-relative w-full line-height-md qa-document"}>
      {header}
      {body}
      {footer}
    </div>
  )
}